// Datos de Repositorio de PHP
let URL_BACK = 'https://apiback.presenciaonline.com.mx/srBotana'
export {
    URL_BACK   
}